export function resolveAppointmentSystemType(doctor, _workspace) {
    return doctor?.appointmentSystemType === "QMS" ? "QMS" : "SCHEDULED";
}
